import axios from "axios";

export const FetchPlaceholderFields = async (token) => {
    try {
        const res = await axios.get("dialer/xbucketdata-fields/", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // console.log(res, "====================Response============");
        return res;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw err.response?.data?.message || err.message || "Failed to fetch placeholder fields";
        } else {
            throw err;
        }
    }
};

export const fetchPortfolioCampaigns = async (token,portfolioId) => {
    try {
        const res = await axios.get(`dialer/campaigns/?portfolio_id=${portfolioId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // console.log(res, "====================PortfolioCampaignResponse============");
        return res;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw err.response?.data?.message || err.message || "Failed to fetch portfolio campaigns";
        } else {
            throw err;
        }
    }
};

export const AddCallScript = async (token, data) => {
    try {
        const res = await axios.post("dialer/call-scripts/", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // console.log(res, "====================AddCallScriptResponse============");
        return res;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw err.response?.data?.message || err.message || "Failed to add call script";
        } else {
            throw err;
        }
    }
};

export const EditCallScript = async (token, id, data) => {
    try {
        const res = await axios.patch(`dialer/call-scripts/?id=${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // console.log(res, "====================EditCallScriptResponse============");
        return res;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw err.response?.data?.message || err.message || "Failed to edit call script";
        } else {
            throw err;
        }
    }
};

export const DeleteCallScript = async (token, id) => {
    try {
        const res = await axios.delete(`dialer/call-scripts/?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log(res, "====================CallDeleteResponse===================");
        return res;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw err.response?.data?.message || err.message || "Failed to delete call script";
        } else {
            throw err;
        }
    }
}